/**
 * Editorial content for the IPO Reviews pages: how the Capital Market (CM)
 * rating bands read. Review calls themselves come from the broker-reviews API.
 */

// How Capital Market scores translate into a subscription call (bands are in utils/ipoReviews)
export const CM_METHODOLOGY = [
  {
    band: 'must',
    range: 'Score 51+',
    verdict: 'Must Subscribe',
    profile: 'Low risk, moderate to high return profile',
    detail: 'Strong balance sheet, credible promoters, clean governance, and attractive valuations compared to listed peers.',
    footer: 'Consensus: Strong Institutional Buy',
  },
  {
    band: 'may',
    range: 'Score 45 - 50',
    verdict: 'May Subscribe',
    profile: 'Low risk low return OR Moderate risk moderate return',
    detail: 'Decent business fundamentals, fair issue pricing, but potential growth or working capital challenges in medium term.',
    footer: 'Selective Long-Term Allocation',
  },
  {
    band: 'high',
    range: 'Score 40 - 44',
    verdict: 'High Risk / Active Seekers',
    profile: 'High-risk high return potential',
    detail: 'Aggressively priced or high financial debt, but positioned in a booming tailwind sector. Only for seasoned investors.',
    footer: 'Avoid for Retail / Conservative',
  },
  {
    band: 'avoid',
    range: 'Score < 40',
    verdict: 'Do Not Subscribe',
    profile: 'High risk, low/moderate return profile',
    detail: 'Expensive valuation, negative operating cash flows, high promoter pledging, or severe corporate governance concerns.',
    footer: 'Recommendation: Outright Avoid',
  },
];

